/* eslint react/forbid-prop-types:0 */

import React from 'react';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';

const styles = {
  alternativesSeparator: {
    marginBottom: '3px',
    overflow: 'hidden',
    textAlign: 'center',
    color: '#333',
    fontWeight: 'bold',
  },
};

export function AlternativesSeparator(props, context) {
  const text = props.text || i18n._('OR');
  const textStyle = Object.assign({}, styles.alternativesSeparator, props.css);
  let className = '';
  if (props.signupSeparatorContinuous) {
    className = 'AlternativesSeparatorContinuous';
  }
  return (
    <p className={className} style={textStyle}>
      {text}
    </p>
  );
}

AlternativesSeparator.propTypes = {
  css: PropTypes.object,
  signupSeparatorContinuous: PropTypes.bool,
  text: PropTypes.string,
};

AlternativesSeparator.defaultProps = {
  css: {},
};

AlternativesSeparator.contextTypes = {
  pageType: PropTypes.string,
  userAgent: PropTypes.shape({
    isMobile: PropTypes.bool.isRequired,
  }).isRequired,
};

export default AlternativesSeparator;
